import { CsvColumn } from "./model";

export interface CsvExportOptionsFormat {
	delimeter: string;
	espaceChar: string;
}

export interface CsvExportOptions<T> {
	columns: CsvColumn<T>[];
	format: CsvExportOptionsFormat;
}

export function csvExport<T>(items: T[], options: CsvExportOptions<T>) {
	var result = '';

	var headers = options.columns.map(column => column.title);
	result += generateRow(headers, options.format);

	for (const item of items) {
		var row = options.columns.map(column => column.valueProvider(item));
		result += generateRow(row, options.format);
	}

	return result;
}

function escapeString(str: string, format: CsvExportOptionsFormat) {
	if (!str)
		return '';

	const formatters = [espaceEspaceChar, espaceDelimeter, espaceNewLine];

	return formatters.reduce((memo, formatter) => formatter(memo), str);

	function espaceEspaceChar(input: string) { 
		return input.replace(format.espaceChar, format.espaceChar + format.espaceChar);
	};

	function espaceDelimeter(input: string) { 
		return input.indexOf(format.delimeter) === -1
			? input
			: format.espaceChar + input + format.espaceChar;
	};

	function espaceNewLine(input: string) {
		return input.indexOf('\n') === -1
			? input
			: format.espaceChar + input + format.espaceChar;
	};
}
function generateRow(values: string[], format: CsvExportOptionsFormat) {
	return values.map(value => escapeString(value, format)).join(',') + '\r\n';
}